import './index.css';
import { noConnectionCameraIcon } from '../../assets';

import AgoraRTC from 'agora-rtc-sdk-ng';
import { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import CallStore from '../../stores/CallStore';
import SocketStore from '../../stores/SocketStore';
import AuthStore from '../../stores/AuthStore';
import { observer } from 'mobx-react';
import ShapesContainer from '../Shapes';
import strings from '../../localization';
import TechCallContainerBottom from '../TechCallContainerBottom';
import ScreenShotStore from '../../stores/ScreenShotStore';
import TechCallRecording from '../TechCallRecording';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';

const APP_ID = "ed4c0ffd56054721a1b4cd90e0cf0dfd";

const NoConnectionContainer = ({ isPermissionGranted, setIsPermissionGranted }) => {

  const requestPermission = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        setIsPermissionGranted(true);
      })
      .catch((error) => {
        console.error("Kullanıcı izin vermedi veya başka bir hata oluştu:", error);
      });
  }

  useEffect(() => {
    requestPermission();
  }, []);

  return (
    <div className="tech-call-no-connection-container">
      <img src={noConnectionCameraIcon} alt="no-connection-camera" />
      <span>{strings.customerVideoStream}</span>
    </div>
  );
};

const TechCallContainer = ({ setClient }) => {

  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);

  const remoteVideoRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [callToken, setCallToken] = useState('');
  const [isPermissionGranted, setIsPermissionGranted] = useState(false);
  const slug = CallStore.slug;

  const client = AgoraRTC.createClient({
    mode: 'rtc',
    codec: 'vp8',
    audioTrack: true,
    videoTrack: true,
    role: 'host',
  });



  const [remoteVideoTrack, setRemoteVideoTrack] = useState(null);
  const [remoteAudioTrack, setRemoteAudioTrack] = useState(null);

  const localAudioTrackRef = useRef(null);
  const remoteAudioTrackRef = useRef(null);




  const getToken = async (slug) => {
    if (!slug) return;
    if (callToken) return;
    const response = await CallStore.getCallToken(slug);
    if (response.success) {
      setCallToken(response.data);
      start(response.data, slug);
      SocketStore.connectTechSocket(slug, AuthStore.token);
    } else {
      showModalAlert({
        title: strings.error,
        message: response.message,
        confirmText: strings.ok,
        type: "error",
        onConfirm: () => {
          closeModalAlert();
        },
        onCancel: null
      });
    }
  }


  async function emitAudioTrack() {
    const microphones = await AgoraRTC.getMicrophones();
    const _localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
      microphoneId: microphones[0].deviceId,
    });


    localAudioTrackRef.current = _localAudioTrack;
    await client.publish([localAudioTrackRef.current]);

  }


  const muteLocalAudioTrack = async () => {
    await localAudioTrackRef.current.setEnabled(false);
  }

  async function start(callToken, slug) {

    try {
      const token = callToken || null;
      const uid = 1000;

      await client.join(APP_ID, slug, token, uid);

      emitAudioTrack();

      setClient(client);
    }

    catch (error) {
      console.error('Agora başlatma hatası:', error);

      // Token hatası ise, token olmadan tekrar dene
      if (error.message.includes('token') || error.message.includes('gateway') || error.message.includes('OPERATION_ABORTED')) {
        getToken(slug, true);
        try {
          // await client.join(APP_ID, slug, null, new Date().getTime().toString());

        } catch (retryError) {
          console.error('Token olmadan da bağlantı başarısız:', retryError);
        }
      }
    }


  }


  const params = useParams();

  useEffect(() => {
    if (params.slug && params.slug !== null) {
      CallStore.setSlug(params.slug);
      CallStore.getCall(params.slug);
    }
    if (params.slug) {
      getToken(params.slug);
    }
  }, [0]);



  useEffect(() => {
    client.on('user-published', async (user, mediaType) => {


      if (user.uid === 1001) {
        try {
          setIsConnected(true);
          await client.subscribe(user, mediaType);

          if (mediaType === 'video') {
            let remoteTrack = user.videoTrack;
            setRemoteVideoTrack(remoteTrack);
            ScreenShotStore.setTracker(remoteTrack);

            setTimeout(() => {
              remoteTrack.play(remoteVideoRef.current);
            }, 2000);

          }

          if (mediaType === 'audio') {
            let _remoteAudioTrack = user.audioTrack;
            _remoteAudioTrack.play(document.createElement('div'), { autoPlay: true });
            setRemoteAudioTrack(_remoteAudioTrack);
            remoteAudioTrackRef.current = _remoteAudioTrack;
          }
        } catch (subscribeError) {
          console.error('Uzak kullanıcıya abone olma hatası:', subscribeError);
        }
      }
    });


    client.on('user-unpublished', (user) => {
    });

    client.on('user-joined', async (user) => {
      // await emitAudioTrack();
    });

    client.on('user-left', (user) => {
      setIsConnected(false);
    });

    client.on('error', (err) => {
      console.error('Agora client hatası:', err);
    });

    client.on('connection-state-change', (curState, prevState) => {
    });
  }, [client]);


  const handleClick = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    if (SocketStore.selectedShape === 'free-hand' || SocketStore.selectedShape === 'color') {
      return;
    }

    if (SocketStore.selectedShape === 'eraser') {
      const shape = SocketStore.getShapeByCoordinates(x, y);
      if (shape) {
        handleShapeRemove(shape.id);
      }
      return;
    }

    if (SocketStore.selectedShape) {
      SocketStore.sendShapeClick(x, y, SocketStore.selectedShape, SocketStore.selectedShapeColor);
    }


  };

  const handleMouseMove = (event) => {
    if (SocketStore.selectedShape !== 'free-hand') return;
    if (Math.random() < 0.5) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    SocketStore.sendFreeHandShape(x, y);
  }

  const handleMouseLeave = () => {
    SocketStore.sendFreeHandShape(-1, -1);
  }

  const handleShapeRemove = (id) => {
    SocketStore.sendShapeRemove(id);
  }

  return (
    <div className="teach-call-container">
      <div className="teach-call-container-header">
        <span className="teach-call-container-header-title">{strings.liveSessionVideoCall}</span>

        <div className='tech-call-container-header-right-div' >
          <TechCallRecording remoteVideoTrack={remoteVideoTrack} />
        </div>
      </div>
      <div className="teach-call-container-content">
        {!isConnected && <NoConnectionContainer slug={slug} isPermissionGranted={isPermissionGranted} setIsPermissionGranted={setIsPermissionGranted} />}
        <div className="teach-call-container-main-div"
          style={{
            visibility: isConnected ? 'visible' : 'hidden',
          }}
        >
          <div
            ref={remoteVideoRef}
            style={{
              width: CallStore.customerScreenResolution?.width,
              height: CallStore.customerScreenResolution?.height,
            }}
          />
        </div>
        {isConnected && <div className="tech-call-container-shapes-outer-div"
          style={{
            width: CallStore.customerScreenResolution?.width,
            height: CallStore.customerScreenResolution?.height,
            visibility: isConnected ? 'visible' : 'hidden',
          }}
        >
          <div
            id="cursor-div"
            onClick={handleClick}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
              width: CallStore.customerScreenResolution?.width,
              height: CallStore.customerScreenResolution?.height,
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 100000,
              margin: 'auto',
            }}
          />
          <ShapesContainer />
        </div>}
      </div>
      {
        remoteAudioTrack && remoteVideoTrack &&
        < TechCallContainerBottom
          remoteAudioTrack={remoteAudioTrack} remoteVideoTrack={remoteVideoTrack}
          localAudioTrackRef={localAudioTrackRef}
          remoteAudioTrackRef={remoteAudioTrackRef}
        />
      }
    </div>
  );
};

export default observer(TechCallContainer);